import '../styles/Loader.scss'
import React from 'react'

type LoaderProps = {
  visible?: boolean
  fullscreen?: boolean
  message?: string
  size?: 'small' | 'medium' | 'large'
}

const Loader: React.FC<LoaderProps> = ({
  visible = true,
  fullscreen = false,
  message,
  size = 'medium',
}) => {
  if (!visible) return null

  const classes = [
    'tm-loader',
    fullscreen ? 'tm-loader--fullscreen' : '',
    !fullscreen ? `tm-loader-size--${size}` : '',
  ]

  return (
    <div className={classes.filter(Boolean).join(' ')} role="status" aria-live="polite">
      <div className="tm-loader__box">
          <svg className="tm-spinner" viewBox="0 0 50 50" aria-hidden>
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
          </svg>

        {message && <div className="tm-loader__message">{message}</div>}
      </div>
    </div>
  )
}

export default Loader
